import { Label, Modal } from "flowbite-react";
import React from "react";
import { toast } from "react-hot-toast";

const MyModal = ({ data, dataFn, allData, setAllData }) => {
  const handleProductForm = (e) => {
    e.preventDefault();
    const form = e.target;
    const checker = /^[0-9]+$/;
    const productName = form.productName.value;
    const unitPrice = form.price.value;
    const quantity = form.quantity.value;
    if (unitPrice.match(checker)) {
      const totalPrice = unitPrice * quantity;
      const productData = {
        desc: productName,
        rate: parseInt(unitPrice),
        qty: parseInt(quantity),
        totalPrice,
      };

      if (allData.length < 0) {
        setAllData([productData]);
      } else {
        setAllData([...allData, productData]);
      }
      form.reset();
      dataFn(!data);
    } else {
      toast.error("Only Number is accepted on Unit Price input");
    }
  };

  return (
    <div>
      <React.Fragment>
        <Modal show={data} size="md">
          <Modal.Header onClick={() => dataFn(!data)} />
          <Modal.Body>
            <div
              onSubmit={handleProductForm}
              className="space-y-6 px-6 pb-4 sm:pb-6 lg:px-8 xl:pb-8"
            >
              <form>
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="productName" value="Product Name" />
                  </div>
                  <input
                    id="productName"
                    placeholder="Napa extra 500ml"
                    name="productName"
                    className="w-full block border-2 p-3 rounded"
                    required
                  />
                </div>
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="quantity" value="Quantity" />
                  </div>
                  <input
                    id="quantity"
                    type="number"
                    name="quantity"
                    className="w-full block border-2 p-3 rounded"
                    required
                  />
                </div>
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="price" value="Unit Price" />
                  </div>
                  <input
                    id="price"
                    type="number"
                    name="price"
                    className="w-full block border-2 p-3 rounded"
                    required
                  />
                </div>
                <div>
                  <button
                    className="inline-block bg-gradient-to-r from-cyan-500 to-blue-500 
                px-4 text-center w-full py-2 my-3 text-white font-medium text-lg rounded-lg"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </div>
  );
};

export default MyModal;
